export const memoizeLast = (f: (arg: any) => void) => {
    let lastArg: any = null;
    let lastResult: any;
    return (arg?: any) => {
        if (arg === lastArg) return lastResult;
        lastArg = arg;
        lastResult = f(arg);
        return lastResult;
    };
};

export const serializeMsgPartsMemoized = memoizeLast((messageParts: any[]) =>
    messageParts.map((part) => {
        if (typeof part !== 'object' || !part) return part;
        if (part instanceof Error) {
            // Error
            return {
                name: part.name,
                message: part.message,
                constructorName: part.constructor?.name || '',
                stack: part.stack,
            };
        }
        if (part.window === part) {
            // Window
            return {
                name: part.name,
                href: part.location?.href,
                top: part === part.top,
                closed: part.closed,
            };
        }
        if (part.ownerDocument) {
            // HTMLElement
            return {
                nodeName: part.nodeName,
                docUri: part.ownerDocument?.documentURI,
                docTitle: part.ownerDocument?.title,
                docVisibilityState: part.ownerDocument?.visibilityState,
            };
        }
        if (part.toString) {
            // etc
            return part;
        }
        return '[non-serializable value]';
    })
);

export const downloadFile = (url: string, name: string) => {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (name) {
        anchor.download = name;
    }
    document.body.appendChild(anchor);

    if (typeof MouseEvent === 'function') {
        anchor.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            })
        );
    } else {
        const event = document.createEvent('Event');
        event.initEvent('click', true, true);
        anchor.dispatchEvent(event);
    }
    document.body.removeChild(anchor);
};
